// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2 ? "035175d8" : chunkId) + "." + {"2":"0e658b2eb0cf083d","112":"0700ab992aa34ff8","508":"5d0d43302028f2c0","833":"6ca94554773b4049","870":"0f43ffb2c39d0c33"}[chunkId] + ".js";
};